/**
 * Detect available visibility property and event name, create listener.
 * @todo it seems like duplicate, I'm sure we have another one somewhere.
 * @param {boolean} predicate Condition to start listen visibilityChange
 * @param {function():void} cb
 */
export function onVisibilityChange(predicate, cb) {
  if(predicate === false) {
    return;
  }
  // let hidden;
  let visibilityChange;
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    // hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    // hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    // hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  if (visibilityChange) {
    document.addEventListener(visibilityChange, cb, false);
  }
}
